// General
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './BlogContent.css';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
class BlogContent extends Component {
    render() {
        const { initialValues, locale } = this.props;
        let addClass = 'ql-editor frontend';

        let date = new Date(initialValues.createdAt);

        let dateFormated = new Intl.DateTimeFormat(locale, { dateStyle: 'full' }).format(date);

        return (
            <Grid fluid className={s.root}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop3, s.space6)}>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div>
                                <h1 className={s.titleText}>{initialValues.pageTitle}</h1>
                            </div>
                            <div className={s.blogDate}><time datetime={date.toISOString()}>{dateFormated}</time></div>
                            <div className={s.subText}>
                                <div
                                    className={addClass}
                                    dangerouslySetInnerHTML={{ __html: initialValues.contentParsed }}
                                >
                                </div>
                            </div>
                        </Col>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BlogContent)));



// WEBPACK FOOTER //
// src/components/BlogContent/BlogContent.js